export const getConsumoAgua = (state) => state.consumoAgua.lista
export const getTotalConsumoAgua = (state) => state.consumoAgua.total
export const getIsCarregandoListaConsumoAgua = (state) => state.consumoAgua.isCarregandoLista
export const getConsumoAguaSelecionado = (state) => state.consumoAgua.selecionado
export const getIsCarregandoConsumoAgua = (state) => state.consumoAgua.isCarregandoConsumoAgua
export const getIsSavingConsumoAgua = (state) => state.consumoAgua.isSaving
